import Api from './baseApi'

export default {

  getCategories() {
    return Api.get('/api/categories')
  },


  getCategoryTree() {
    return Api.get('/api/categories/tree')
  },


  getCategory(id) {
    return Api.get(`/api/categories/${id}`)
  },

  getCategoriesByParent(parentId = null) {
    const url = parentId ? `/api/categories/by-parent/${parentId}` : '/api/categories/by-parent'
    return Api.get(url)
  },

  getRootCategories() {
    return Api.get('/api/categories/roots')
  },

  createCategory(category) {
    return Api.post('/api/categories', category)
  },


  updateCategory(id, category) {
    return Api.put(`/api/categories/${id}`, category)
  },

  deleteCategory(id) {
    return Api.delete(`/api/categories/${id}`)
  },


  checkCategoryKey(categoryKey, excludeId = null) {
    const params = excludeId ? `?excludeId=${excludeId}` : ''
    return Api.get(`/api/categories/check-key/${categoryKey}${params}`)
  },

  checkCategoryName(name, excludeId = null) {
    const params = excludeId ? `?excludeId=${excludeId}` : ''
    return Api.get(`/api/categories/check-name/${encodeURIComponent(name)}${params}`)
  },

  getMaxSortOrder(parentId = null) {
    const params = parentId ? `?parentId=${parentId}` : ''
    return Api.get(`/api/categories/max-sort-order${params}`)
  }
}